import React, { useEffect, useState } from "react";
import TextField from "../Partial/TextField";
import Button from "../Partial/Button";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  createUserApiCall,
  loginApiCall,
} from "../../store/actions/projectAction";
import { Link, useNavigate } from "react-router-dom";
import { ROTUES } from "../../utils/global";
import SelectField from "../Partial/SelectField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  getAuth,
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
  signInWithPhoneNumber,
} from "firebase/auth";
import { toast } from "react-toastify";
import OtpEnterScreen from "./OtpVarifier";
import { setLoading } from "../../store/reducer/projectSlice";

const statusOptions = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];

function Register() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const [confirmationResult, setConfirmationResult] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = getAuth();
  auth.useDeviceLanguage();

  const generateRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {
            dispatch(
              setLoading({
                code: "firebase_register",
                loading: true,
              })
            );
          },
          "expired-callback": () => {
            window.recaptchaVerifier.render().then(function (widgetId) {
              window.grecaptcha.reset(widgetId); // Reset CAPTCHA on expiration
            });
          },
        }
      );
    }
  };

  const handleLogin = async (data) => {
    const phoneNumber = data?.phone;

    // generateRecaptcha();
    const appVerifier = window.recaptchaVerifier;
    const formattedPhoneNumber = phoneNumber.startsWith("+")
      ? phoneNumber
      : `+${phoneNumber}`;

    signInWithPhoneNumber(auth, formattedPhoneNumber, appVerifier)
      .then((result) => {
        dispatch(
          setLoading({
            code: "firebase_register",
            loading: false,
          })
        );
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        setConfirmationResult(result);
        window.confirmationResult = result;
        toast.success("Otp is sent to your mobile number");
        window.localStorage.setItem("registerInfo", JSON.stringify(data));
      })
      .catch((error) => {
        dispatch(
          setLoading({
            code: "firebase_register",
            loading: false,
          })
        );
        const errorCode = error.code;
        if (errorCode == "auth/billing-not-enabled") {
          toast.error("Please try again service is not available");
        }
        // window.recaptchaVerifier.render().then(function (widgetId) {
        //   window.grecaptcha.reset(widgetId);
        // });

        // window?.grecaptcha.reset(window.recaptchaWidgetId);
      });
  };

  const handleOnOtpVarify = async (otp, data) => {
    const enteredOtp = otp.join(""); // Join the OTP array into a string

    const registerInfoJson = window.localStorage.getItem("registerInfo");
    const registerInfo = registerInfoJson ? JSON.parse(registerInfoJson) : null;

    if (!window?.confirmationResult || !registerInfo) {
      return;
    }
    try {
      dispatch(
        setLoading({
          code: "firebase_register_varify",
          loading: true,
        })
      );
      var credential = await PhoneAuthProvider.credential(
        window.confirmationResult.verificationId,
        enteredOtp
      );

      const auth = getAuth();

      const userCredential = await signInWithCredential(auth, credential);
      const user = userCredential.user;

      const token = await user.getIdToken();
      window.localStorage.setItem("token", token);
      dispatch(
        setLoading({
          code: "firebase_register_varify",
          loading: false,
        })
      );
      dispatch(
        createUserApiCall({
          ...registerInfo,
          role: "user",
          token,
        })
      ).then((result) => {
        if (result?.payload?.success) {
          // window.location.href = ROTUES.login;
          window.recaptchaVerifier.render().then(function (widgetId) {
            window.grecaptcha.reset(widgetId);
          });
          navigate(ROTUES.login);
        }
      });
    } catch (error) {
      dispatch(
        setLoading({
          code: "firebase_register_varify",
          loading: false,
        })
      );
      const errorCode = error.code;

      if (errorCode == "auth/invalid-verification-code") {
        toast.error("Invalid varification code");
      }
    }
  };

  useEffect(() => {
    generateRecaptcha();
  }, []);

  return (
    <div className="w-full flex">
      <div className="w-[50%] h-screen bg-[#00428C]"></div>
      <div className="w-[50%] h-[100vh] flex flex-col justify-center items-center">
        <div className="w-[100%] md:w-[50%] lg:w-[50%] flex gap-[30px] flex-col justify-center items-center px-2 md:px-0 lg:px-0">
          <div className="flex">
            <div className="w-[200px] h-[180px]  rounded-md flex justify-center items-center">
              <img
                src="/Logo_Transaprent.png"
                alt="logo"
                className="w-full h-full"
              />
            </div>
          </div>

          {!confirmationResult && (
            <form
              className="w-full flex flex-col gap-[16px]"
              onSubmit={handleSubmit(handleLogin)}
            >
              <div className="flex w-full h-full flex-col gap-[10px]">
                <div>
                  <TextField
                    placeholder="Enter your email"
                    name="email"
                    register={register("email", {
                      required: "Email is required!",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid email address",
                      },
                    })}
                    //   value={formState.email.value}
                    //   onChange={handleChangeForm}
                    errorMessage={errors?.email?.message}
                  />
                  {/* <p className="text-red-600">{errors?.email?.message}</p> */}
                </div>
                <div>
                  <PhoneInput
                    country={"in"}
                    enableSearch
                    placeholder="Enter your phone"
                    inputStyle={{ width: "100%" }}
                    onChange={(value) => setValue("phone", value)} // Validate on change
                  />
                  <input
                    type="hidden"
                    {...register("phone", {
                      required: "Phone number is required",
                      validate: (value) => {
                        const phoneWithoutCode = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                        return (
                          phoneWithoutCode.length - 2 === 10 ||
                          "Phone number must be exactly 10 digits"
                        );
                      },
                    })}
                  />
                  {errors.phone && (
                    <p className="text-red-400 text-left ml-1 text-sm">
                      {errors.phone.message}
                    </p>
                  )}
                </div>

                <TextField
                  placeholder="Enter Full Name"
                  register={register("name", {
                    required: "Full Name is required",
                  })}
                  errorMessage={errors.name?.message}
                />
                <div className="flex justify-end">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      window.location.href = ROTUES.login;
                    }}
                  >
                    Already have account ?
                  </div>
                </div>
              </div>
              {/* <div id="recaptcha-container"></div> */}
              <Button
                type="submit"
                text="Create Account"
                className="w-full"
                id="create-account-btn"
                // isLoading={isLoading}
              />
            </form>
          )}

          <div id="recaptcha-container"></div>

          {confirmationResult && (
            <OtpEnterScreen onOtpVarifyCallback={handleOnOtpVarify} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Register;
